export const colors = [
    // Icon Colors
    {
        type: ["full"],
        color: ["gray"],
        icon: ["dot"],
        class: ["[&_svg]:text-alpha-black-20"],
    },
    {
        type: ["full"],
        color: ["error"],
        icon: ["dot"],
        class: ["[&_svg]:text-alpha-white-70"],
    },
    {
        type: ["full"],
        color: [
            "warning",
            "success",
            "gray-blue",
            "blue-light",
            "blue",
            "indigo",
            "purple",
            "pink",
            "orange",
        ],
        icon: ["dot"],
        class: ["[&_svg]:text-alpha-white-50"],
    },
    {
        type: ["light"],
        color: ["gray"],
        icon: ["dot"],
        class: ["[&_svg]:text-utility-gray-500"],
    },
    {
        type: ["light"],
        color: ["brand"],
        icon: ["dot"],
        class: ["[&_svg]:text-utility-brand-500"],
    },
    {
        type: ["light"],
        color: ["error"],
        icon: ["dot"],
        class: ["[&_svg]:text-utility-error-500"],
    },
    {
        type: ["light"],
        color: ["warning"],
        icon: ["dot"],
        class: ["[&_svg]:text-utility-warning-500"],
    },
    {
        type: ["light"],
        color: ["success"],
        icon: ["dot"],
        class: ["[&_svg]:text-utility-success-500"],
    },
    {
        type: ["full"],
        color: ["gray"],
        icon: ["close"],
        class: ["[&_svg]:text-alpha-black-40"],
    },
    {
        type: ["full"],
        color: [
            "brand",
            "error",
            "warning",
            "gray-blue",
            "blue-light",
            "purple",
            "pink",
            "orange",
        ],
        icon: ["close"],
        class: ["[&_svg]:text-alpha-white-60"],
    },
    {
        type: ["light"],
        color: ["gray"],
        icon: ["close"],
        class: ["[&_svg]:text-utility-gray-400"],
    },
    {
        type: ["light"],
        color: ["brand"],
        icon: ["close"],
        class: ["[&_svg]:text-utility-brand-400"],
    },
    {
        type: ["light"],
        color: ["error"],
        icon: ["close"],
        class: ["[&_svg]:text-utility-error-400"],
    },
    {
        type: ["light"],
        color: ["warning"],
        icon: ["close"],
        class: ["[&_svg]:text-utility-warning-400"],
    },
    {
        type: ["full", "light"],
        color: ["success"],
        icon: ["close"],
        class: ["[&_svg]:text-utility-success-400"],
    },
    {
        type: ["light"],
        color: ["gray-blue"],
        icon: ["close"],
        class: ["[&_svg]:text-utility-gray-blue-400"],
    },
    {
        type: ["light"],
        color: ["blue-light"],
        icon: ["close"],
        class: ["[&_svg]:text-utility-blue-light-400"],
    },
    {
        type: ["full", "light"],
        color: ["blue"],
        icon: ["close"],
        class: ["[&_svg]:text-utility-blue-400"],
    },
    {
        type: ["full", "light"],
        color: ["indigo"],
        icon: ["close"],
        class: ["[&_svg]:text-utility-indigo-400"],
    },
    {
        type: ["light"],
        color: ["purple"],
        icon: ["close"],
        class: ["[&_svg]:text-utility-purple-400"],
    },
    {
        type: ["light"],
        color: ["pink"],
        icon: ["close"],
        class: ["[&_svg]:text-utility-pink-400"],
    },
    {
        type: ["light"],
        color: ["orange"],
        icon: ["close"],
        class: ["[&_svg]:text-utility-orange-400"],
    },
    {
        type: ["full"],
        color: ["gray"],
        icon: ["trailing", "leading", "only"],
        class: ["[&_svg]:text-utility-gray-500"],
    },
    // Label Colors
    {
        type: ["color", "outline", "light"],
        color: ["gray"],
        class: ["text-utility-gray-700"],
    },
    {
        type: ["color", "outline", "light"],
        color: ["brand"],
        class: ["text-utility-brand-700"],
    },
    {
        type: ["color", "outline", "light"],
        color: ["error"],
        class: ["text-utility-error-700"],
    },
    {
        type: ["color", "outline", "light"],
        color: ["warning"],
        class: ["text-utility-warning-700"],
    },
    {
        type: ["color", "outline", "light"],
        color: ["success"],
        class: ["text-utility-success-700"],
    },
    {
        type: ["color", "outline", "light"],
        color: ["gray-blue"],
        class: ["text-utility-gray-blue-700"],
    },
    {
        type: ["color", "outline", "light"],
        color: ["blue-light"],
        class: ["text-utility-blue-light-700"],
    },
    {
        type: ["color", "outline", "light"],
        color: ["blue"],
        class: ["text-utility-blue-700"],
    },
    {
        type: ["color", "outline", "light"],
        color: ["indigo"],
        class: ["text-utility-indigo-700"],
    },
    {
        type: ["color", "outline", "light"],
        color: ["purple"],
        class: ["text-utility-purple-700"],
    },
    {
        type: ["color", "outline", "light"],
        color: ["pink"],
        class: ["text-utility-pink-700"],
    },
    {
        type: ["color", "outline", "light"],
        color: ["orange"],
        class: ["text-utility-orange-700"],
    },
    {
        type: ["full"],
        color: ["gray"],
        class: ["text-secondary"],
    },
    // Background & Border Colors
    {
        type: ["color"],
        color: ["gray"],
        class: ["bg-utility-gray-50", "border-utility-gray-200"],
    },
    {
        type: ["color"],
        color: ["brand"],
        class: ["bg-utility-brand-50", "border-utility-brand-200"],
    },
    {
        type: ["color"],
        color: ["error"],
        class: ["bg-utility-error-50", "border-utility-error-200"],
    },
    {
        type: ["color"],
        color: ["warning"],
        class: ["bg-utility-warning-50", "border-utility-warning-200"],
    },
    {
        type: ["color"],
        color: ["success"],
        class: ["bg-utility-success-50", "border-utility-success-200"],
    },
    {
        type: ["color"],
        color: ["gray-blue"],
        class: ["bg-utility-gray-blue-50", "border-utility-gray-blue-200"],
    },
    {
        type: ["color"],
        color: ["blue-light"],
        class: ["bg-utility-blue-light-50", "border-utility-blue-light-200"],
    },
    {
        type: ["color"],
        color: ["blue"],
        class: ["bg-utility-blue-50", "border-utility-blue-200"],
    },
    {
        type: ["color"],
        color: ["indigo"],
        class: ["bg-utility-indigo-50", "border-utility-indigo-200"],
    },
    {
        type: ["color"],
        color: ["purple"],
        class: ["bg-utility-purple-50", "border-utility-purple-200"],
    },
    {
        type: ["color"],
        color: ["pink"],
        class: ["bg-utility-pink-50", "border-utility-pink-200"],
    },
    {
        type: ["color"],
        color: ["orange"],
        class: ["bg-utility-orange-50", "border-utility-orange-200"],
    },
    {
        type: ["outline"],
        color: ["gray"],
        class: ["border-utility-gray-400"],
    },
    {
        type: ["outline"],
        color: ["brand"],
        class: ["border-utility-brand-400"],
    },
    {
        type: ["outline"],
        color: ["error"],
        class: ["border-utility-error-400"],
    },
    {
        type: ["outline"],
        color: ["warning"],
        class: ["border-utility-warning-400"],
    },
    {
        type: ["outline"],
        color: ["success"],
        class: ["border-utility-success-400"],
    },
    {
        type: ["outline"],
        color: ["gray-blue"],
        class: ["border-utility-gray-blue-400"],
    },
    {
        type: ["outline"],
        color: ["blue-light"],
        class: ["border-utility-blue-light-400"],
    },
    {
        type: ["outline"],
        color: ["blue"],
        class: ["border-utility-blue-400"],
    },
    {
        type: ["outline"],
        color: ["indigo"],
        class: ["border-utility-indigo-400"],
    },
    {
        type: ["outline"],
        color: ["purple"],
        class: ["border-utility-purple-400"],
    },
    {
        type: ["outline"],
        color: ["pink"],
        class: ["border-utility-pink-400"],
    },
    {
        type: ["outline"],
        color: ["orange"],
        class: ["border-utility-orange-400"],
    },
    {
        type: ["full"],
        color: ["gray"],
        class: ["bg-utility-gray-200"],
    },
    {
        type: ["full"],
        color: ["brand"],
        class: ["bg-utility-brand-500"],
    },
    {
        type: ["full"],
        color: ["error"],
        class: ["bg-utility-error-600"],
    },
    {
        type: ["full"],
        color: ["warning"],
        class: ["bg-utility-warning-500"],
    },
    {
        type: ["full"],
        color: ["success"],
        class: ["bg-utility-success-500"],
    },
    {
        type: ["full"],
        color: ["gray-blue"],
        class: ["bg-utility-gray-blue-500"],
    },
    {
        type: ["full"],
        color: ["blue-light"],
        class: ["bg-utility-blue-light-500"],
    },
    {
        type: ["full"],
        color: ["blue"],
        class: ["bg-utility-blue-500"],
    },
    {
        type: ["full"],
        color: ["indigo"],
        class: ["bg-utility-indigo-500"],
    },
    {
        type: ["full"],
        color: ["purple"],
        class: ["bg-utility-purple-500"],
    },
    {
        type: ["full"],
        color: ["pink"],
        class: ["bg-utility-pink-500"],
    },
    {
        type: ["full"],
        color: ["orange"],
        class: ["bg-utility-orange-400"],
    },
    {
        type: ["light"],
        color: ["gray"],
        class: ["bg-utility-gray-100"],
    },
    {
        type: ["light"],
        color: ["brand"],
        class: ["bg-utility-brand-100"],
    },
    {
        type: ["light"],
        color: ["error"],
        class: ["bg-utility-error-100"],
    },
    {
        type: ["light"],
        color: ["warning"],
        class: ["bg-utility-warning-100"],
    },
    {
        type: ["light"],
        color: ["success"],
        class: ["bg-utility-success-100"],
    },
    {
        type: ["light"],
        color: ["gray-blue"],
        class: ["bg-utility-gray-blue-100"],
    },
    {
        type: ["light"],
        color: ["blue-light"],
        class: ["bg-utility-blue-light-100"],
    },
    {
        type: ["light"],
        color: ["blue"],
        class: ["bg-utility-blue-100"],
    },
    {
        type: ["light"],
        color: ["indigo"],
        class: ["bg-utility-indigo-100"],
    },
    {
        type: ["light"],
        color: ["purple"],
        class: ["bg-utility-purple-100"],
    },
    {
        type: ["light"],
        color: ["pink"],
        class: ["bg-utility-pink-100"],
    },
    {
        type: ["light"],
        color: ["orange"],
        class: ["bg-utility-orange-100"],
    },
];
